module.exports = __webpack_public_path__ + "static/media/cover-gradient.1ba614f6.png";